import {getPlantIdsPerCountryMap, getPlantName, useUpmPlantsContext} from '@hconnect/upm'
import {getPlantIdsForPermissions, usePermissionsQuery} from '@hproduce/permissions'
import {orderBy} from 'lodash'
import {useMemo} from 'react'

type UseUserPlantListReturn = {plantId: string; plantName: string}[]

export function useUserPlantList(): UseUserPlantListReturn {
  const {data: permissions = []} = usePermissionsQuery()
  const upmPlants = useUpmPlantsContext()
  const plantIdsForCountryMap = getPlantIdsPerCountryMap(upmPlants)

  const allPlants = useMemo(
    () =>
      orderBy(
        getPlantIdsForPermissions(permissions, plantIdsForCountryMap).map((plantId) => ({
          plantId,
          plantName: getPlantName(upmPlants, plantId)
        })),
        'plantName'
      ),
    [permissions, plantIdsForCountryMap, upmPlants]
  )

  return allPlants
}
